import { COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const MessageColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "lmMessage",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    }
];

export default MessageColumns;
